import { render, staticRenderFns } from "./EmployerViewPage.vue?vue&type=template&id=2fba0a4a&"
import script from "./EmployerViewPage.vue?vue&type=script&lang=js&"
export * from "./EmployerViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports